<template>
    <div class="nfse-prefeitura-main">
        <div v-if="nfsePrefeitura.dados.id">
            <Button _key="btnNfseCreate" title="NFSe" classIcon="fas fa-plus-circle" type="primary" size="small"
                eventName="nfsePrefeituraCreate" :clicked="createNew" />
            <div class="nfse-prefeitura-dropdown side-by-side">
                <DropdownOptions :urlPdf="nfsePrefeitura.dados.urlPdf" :urlReceita="nfsePrefeitura.dados.urlReceita"
                    :urlXml="nfsePrefeitura.dados.urlXml" :status="nfsePrefeitura.dados.status"
                    source="nfse-prefeitura" />
            </div>
            <br />
            <Badge v-if="nfsePrefeitura.dados.numero" :title="'Nº ' + nfsePrefeitura.dados.numero.toString()"
                type="primary" size="medium" />
            <Badge v-if="nfsePrefeitura.dados.status" :title="titleStatus()" :type="typeStatus()" size="small" />
            <MensagemErro :status="nfsePrefeitura.dados.status" :mensagemErro="nfsePrefeitura.dados.mensagemErro" />
            <EmProcessamento :status="nfsePrefeitura.dados.status" updateButtonKey="btnUpdateNfsePrefeitura" />
            <div class="nfse-prefeitura-total">
                <DisplayTotalization title="Nota" :value="nfsePrefeitura.dados.valorNota" />
                <DisplayTotalization title="Impostos Aprox..." _style="color: red" :value="nfsePrefeitura.dados.valorImposto" />
                <DisplayTotalization title="Final" _style="color: darkBlue" :value="nfsePrefeitura.dados.valorFinal" />
            </div>
        </div>

        <b-tabs>
            <b-tab title="Dados">
                <Dados v-model="nfsePrefeitura.dados" :disabled="disabled" />
            </b-tab>
            <b-tab title="Regime Tributário">
                <RegimeTributario :disabled="disabled" v-model="nfsePrefeitura.regimeTributario" />
            </b-tab>
            <b-tab v-if="id && (userLogged.user.userName === 'UserTemp' || hasRule('Audit'))" title="Auditoria">
                <TimelineLog :id="id" />
            </b-tab>
            <b-tab v-if="userLogged.user.userName == 'UserTemp'" title="Json">
                <JsonInterpreter :jsonData="nfsePrefeitura.dados.json" :nf="nfsePrefeitura.dados"
                    source="nfse-prefeitura" />
            </b-tab>
        </b-tabs>

        <b-tabs class="nfse-prefeitura-impostos-tabs">
            <b-tab title="Impostos">
                <Imposto :disabled="disabled" :ehSimplesNacional="ehSimplesNacional" :dados="nfsePrefeitura.dados"
                    v-model="nfsePrefeitura.imposto" />
            </b-tab>
            <b-tab title="Totalização de Impostos">
                <Transparencia :disabled="disabled" v-model="nfsePrefeitura.transparencia" />
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>

import Badge from "@nixweb/nixloc-ui/src/component/layout/Badge.vue";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import DisplayTotalization from "@nixweb/nixloc-ui/src/component/rental/DisplayTotalization";

import DropdownOptions from '../nfse-shared/NfseDropdownOptions.vue';
import EmProcessamento from "../nfse-shared/NfseEmProcessamento.vue";
import MensagemErro from '../nfse-shared/NfseMensagemErro.vue';
import JsonInterpreter from '../json/JsonInterpreter.vue';
import TimelineLog from '../../adm/audit-log/TimelineLog.vue';

import Dados from './Dados.vue';
import Imposto from './Imposto.vue';
import NfsePrefeitura from "./NfsePrefeitura.js";
import RegimeTributario from './RegimeTributario.vue';
import Transparencia from './Transparencia.vue';
import { getNfseStatusTitle, getNfseStatusType } from "../nfse-shared/NfseStatus.js";

import { mapActions, mapGetters, mapMutations, mapState } from "vuex";


export default {
    name: "NfsePrefeituraCreateUpdate",
    components: {
        Badge,
        Button,
        DisplayTotalization,
        Dados,
        RegimeTributario,
        Imposto,
        Transparencia,
        MensagemErro,
        EmProcessamento,
        DropdownOptions,
        JsonInterpreter,
        TimelineLog,
    },
    data() {
        return {
            id: this.$route.params.id,
            urlCreate: "/api/v1/tax-document/nfse-prefeitura/create",
            urlUpdate: "/api/v1/tax-document/nfse-prefeitura/update",
            urlGetById: "/api/v1/tax-document/nfse-prefeitura/get-by-id",
            urlGetRegimeTributario: "/api/v1/tax-document/config-company/get-by-id",
            nfsePrefeitura: {
                dados: new NfsePrefeitura().dados,
                regimeTributario: new NfsePrefeitura().regimeTributario,
                imposto: new NfsePrefeitura().imposto,
                transparencia: new NfsePrefeitura().transparencia,
            },
            loading: true,
        }
    },
    mounted() {
        if (this.id) {
            this.getById();
        } else {
            this.obterRegimeTributarioEmpresa();
        }
    },
    computed: {
        ...mapState("user", ["userLogged"]),
        ...mapGetters("generic", ["event"]),
        ...mapGetters("user", ["hasRule"]),
        ehSimplesNacional() {
            return this.nfsePrefeitura.regimeTributario.optanteSimplesNacional;
        },
        disabled() {
            const statusHabilitados = [1, 2, 4];
            return statusHabilitados.includes(this.nfsePrefeitura.dados.status);
        }
    },
    methods: {
        ...mapActions("generic", ["postApi", "putApi", "getApi"]),
        ...mapMutations("generic", ["removeLoading"]),
        ...mapMutations("validation", ["removeFormDirty"]),
        titleStatus() {
            return getNfseStatusTitle(this.nfsePrefeitura.dados.status);
        },
        typeStatus() {
            return getNfseStatusType(this.nfsePrefeitura.dados.status);
        },
        createNew() {
            this.$router.push({
                name: "nfsePrefeituraCreate",
            });
            this.removeLoading(["btnNfseCreate"]);
        },
        create() {
            const nfsePrefeitura = this.createObj();
            let params = { url: this.urlCreate, obj: nfsePrefeitura };
            this.postApi(params).then((response) => {
                if (response.success) {
                    this.$router.replace({
                        name: "nfsePrefeituraUpdate",
                        params: { id: response.content.id },
                    });
                }
                this.removeLoading(["saveSaveCancel"]);
            });
        },
        update(notNotifyToast) {
            const nfsePrefeitura = this.createObj();
            let params = { url: this.urlUpdate, obj: nfsePrefeitura, notNotifyToast: notNotifyToast };
            this.putApi(params).then(() => {
                this.getById();
                this.removeLoading(["saveSaveCancel"]);
            });
        },
        getById() {
            let params = { url: this.urlGetById, obj: { id: this.id } };
            this.getApi(params).then((response) => {
                const data = response.content;
                this.updateObj(data);
                let self = this;
                setTimeout(function () {
                    self.removeLoading(["panel", "btnUpdateNfsePrefeitura"]);
                    self.removeFormDirty();
                }, 100);
            });
        },
        obterRegimeTributarioEmpresa() {
            this.loading = true;
            let params = { url: this.urlGetRegimeTributario, obj: {} };
            this.getApi(params).then((response) => {
                if (response.success) {
                    const data = response.content;
                    this.nfsePrefeitura.regimeTributario.optanteSimplesNacional = data.simplesNacional;
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        createObj() {
            return NfsePrefeitura.createObj(this.nfsePrefeitura);
        },
        updateObj(data) {
            NfsePrefeitura.updateObj(this.nfsePrefeitura, data);
        }
    },
    watch: {
        event: {
            handler(event) {
                if (event.name == "saveSaveCancel") {
                    if (!this.nfsePrefeitura.dados.id) this.create();
                    if (this.nfsePrefeitura.dados.id) this.update();
                }

                if (event.name == "updateNfse") {
                    this.update(true);
                }

                if (event.name == "refreshNfse") {
                    this.getById();
                }
            },
            deep: true,
        },
    },
}
</script>

<style scoped>
.nfse-prefeitura-main {
    margin-top: 40px;
}

.nfse-prefeitura-dropdown {
    margin-bottom: 20px;
    margin-left: -5px;
}

.nfse-prefeitura-total {
    margin-top: 20px;
}

.nfse-prefeitura-impostos-tabs {
    margin-top: 16px;
}
</style>
